<!-- Breadcrumb con nome -->
<app-breadcrumbs class="mb-3" [lastLabel]="(name ?? '')"></app-breadcrumbs>

<mat-card class="mat-elevation-z8 container-card">

    <mat-card-content class="mat-elevation-z8">
        <mat-tab-group (selectedTabChange)="onTabChanged($event)">

            <mat-tab label="Indexes">
                <app-shared-table [dataSource]="dataSourceIndex" [displayedColumns]="['name', 'actions']" [columnLabels]="{name: 'Nome'}" (openModal)="openDialog($event)" [notAllowEdit]="true" [length]="indexTotalItems" [pageSize]="indexPageSize" [pageIndex]="indexPageIndex" (pageChanged)="onPageChanged($event)" [isLoading]="isLoading">
                </app-shared-table>
            </mat-tab>

            <mat-tab label="Patterns">
                <app-shared-table [dataSource]="dataSourcePattern" [displayedColumns]="['pattern', 'type', 'actions']" [columnLabels]="{pattern: 'Pattern', type: 'Azione da eseguire'}" (openModal)="openDialog($event)" [length]="patternTotalItems" [pageSize]="patternPageSize" [pageIndex]="patternPageIndex" (pageChanged)="onPageChanged($event)" [isLoading]="isLoading">
                </app-shared-table>
            </mat-tab>

            <mat-tab label="Fields">
                <app-shared-table [dataSource]="dataSourceMeta" [displayedColumns]="['fieldName', 'value', 'type', 'actions']" [columnLabels]="{fieldName: 'Field', value: 'Testo/Regex', type: 'Azione da eseguire'}" (openModal)="openDialog($event)" [length]="fieldTotalItems" [pageSize]="fieldPageSize" [pageIndex]="fieldPageIndex" (pageChanged)="onPageChanged($event)" [isLoading]="isLoading">
                </app-shared-table>
            </mat-tab>

        </mat-tab-group>
    </mat-card-content>
</mat-card>